import { render, staticRenderFns } from "./TicketsHistory.vue?vue&type=template&id=243ca6a4&scoped=true&"
import script from "./TicketsHistory.vue?vue&type=script&lang=js&"
export * from "./TicketsHistory.vue?vue&type=script&lang=js&"
import style0 from "./TicketsHistory.vue?vue&type=style&index=0&id=243ca6a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243ca6a4",
  null
  
)

export default component.exports